import { render, staticRenderFns } from "./TinTucForm.vue?vue&type=template&id=42bbe7de"
import script from "./TinTucForm.vue?vue&type=script&lang=js"
export * from "./TinTucForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports